import Image, { StaticImageData } from '../image';
import { Title } from '../title';

type color = 'blue' | 'green' | 'yellow' | 'red';
const colors = {
  blue: 'bg-active',
  green: 'bg-[#00C08C]',
  yellow: 'bg-warning',
  red: 'bg-pink',
};
export const DetailHeader = ({
  typeIcon,
  color = 'blue',
  title,
  tagName,
  sourceTitle,
  titleImage,
  hiddenBottom = false,
}: {
  typeIcon: StaticImageData;
  color?: color;
  title: string;
  tagName: string;
  sourceTitle?: string;
  titleImage?: StaticImageData;
  hiddenBottom?: boolean;
}) => {
  return (
    <div className="flex flex-col">
      <div className="flex">
        <div
          className={`flex items-center py-[6px] px-[10px] mobile:px-2 mobile:py-1 rounded-l ${colors[color]}`}
        >
          <Image
            src={typeIcon}
            alt="icon"
            className="w-6 h-6 mobile:w-[18px] mobile:h-[18px]"
            width={18}
            height={18}
          />
        </div>
        <div className="bg-primary h-full flex items-center self-center px-[10px] py-3 rounded-r text-white leading-none text-xs mobile:text-[10px] mobile:px-2 mobile:py-3 ">
          <div>{tagName}</div>
        </div>
      </div>
      <Title className="mt-4" title={title} />
      {!hiddenBottom && (
        <DetailHeaderSupportFooter
          titleImage={titleImage}
          sourceTitle={sourceTitle}
        />
      )}
    </div>
  );
};

export const DetailHeaderSupportFooter = ({
  titleImage,
  sourceTitle,
  reverse = false,
}: {
  titleImage?: StaticImageData;
  sourceTitle?: string;
  reverse?: boolean;
}) => {
  return (
    <div className={`flex items-center ${reverse ? 'flex-row-reverse' : ''}`}>
      <div className="aspect-[130/60] h-[60px] mobile:aspect-[86/40] mobile:h-10">
        <Image
          src={titleImage || ''}
          alt="服务icon"
          width={130}
          height={60}
          className="w-full h-full"
        />
      </div>
      <div className="bg-primary/[.21] h-6 mobile:h-[14px] w-px ml-5 mr-[10px]" />
      <span className="text-sm mobile:text-[10px] text-primary/60 line-clamp-1 break-all">
        该服务由「{sourceTitle}」提供
      </span>
    </div>
  );
};
